<script>

import config from '../../common/genericPanelConf';
import Service from '../../services/stock-management';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';

export default {
    props: ['category', 'name'],
    components: {
        GenericDataTable, ResponsiveButton, GenericBooleanDropdown, GenericCustomMasterDataAutocompleteV2, GenericCustomAutocompleteV2
    },
    data(){
        return{
            
            editItem: {},
            configurationAutomatic: {},
            configurationManual: {},
            configurationManualLock: {},
            filters: {
                referenceDate: Utils.formatDatePlusDays(new Date(),-1),
                plantCode: null
            },
            twentyFour: '24.00',
            showProvenance: false,
            addManualVisible: false,
            excludedTanksVisible: false,
            addExcludedTankVisible: false,
            excludedTanks: [],
            excludedTanksLoading: false,
            addTankExcluded: {},

            externalDataImportItems: [
                {
                    label: 'Lims',
                    command: () => {
                        this.reimportExternal('lims')
                    }
                },
                {
                    label: 'Mts',
                    command: () => {
                        this.reimportExternal('mts')
                    }
                },
                {
                    label: 'Pi',
                    command: () => {
                        this.reimportExternal('pi')
                    }
                },
                {
                    label: this.$t('tankOperations.page_title'),
                    command: () => {
                        this.reimportExternal('equipment')
                    }
                }
            ],
            exportItems: [
                {
                    label: 'Tutti',
                    command: () => {
                        this.exportStock('all')
                    }
                },
                {
                    label: 'Stoccaggi',
                    command: () => {
                        this.exportStock('stock')
                    }
                },
                {
                    label: 'Forward',
                    command: () => {
                        this.exportStock('forward')
                    }
                },
                {
                    label: 'PI',
                    command: () => {
                        this.exportStock('pi')
                    }
                }
            ],
            chooseReportTypeDialogVisible: false,
            selectedReportType: 'PDF',
            reportTypes: [
                {
                    value: 'PDF',
                    label: 'Pdf M+C' 
                },
                {
                    value: 'EXCEL',
                    label: 'Excel M+C' 
                },
                {
                    value: 'PDF-AUTO',
                    label: 'Pdf Auto' 
                },
                {
                    value: 'EXCEL-AUTO',
                    label: 'Excel Auto' 
                }
            ],
            manualLockDialogVisible: false,
            manualLockDailyTankRecordRequest: {
                id: null,
                propagate: false
            }
        }
    },
    created(){
        this.configurationAutomatic = {...config.getConfiguration(this.name)};
        this.configurationAutomatic.api = 'stock-management/daily-tank-auto';
        this.configurationAutomatic.enableUpdate = false;
        this.configurationAutomatic.enableDelete = false;
        this.configurationAutomatic.enableInsert = false;

        this.configurationManual = {...config.getConfiguration(this.name)};
        this.configurationManual.api = 'stock-management/daily-tank-manual';

        this.configurationManual.customActions = [
            {
                name: 'stockManagementDailyTankDeleteButton',
                title: 'btn.delete',
                visible: false,
                cssClass: 'p-button-sm p-button-rounded p-button-warning mr-2',
                icon: 'pi pi-trash',
                data: {},
                fields: [],
                action: function (data, caller) {
                    caller.$emit('onStockManagementDailyTankDelete', data);
                }
            },
            {
                name: 'stockManagementDailyTankManualLockTankButton',
                title: 'StockManagementDailyTank.btn.manualLockTank',
                visible: (data) => { return data.type != "Locked" },
                cssClass: 'p-button-sm p-button-rounded p-button-warning mr-2',
                icon: 'pi pi-lock',
                data: {},
                fields: [],
                action: function (data, caller) {
                    caller.$emit('onStockManagementDailyTankManualLockTank', data);
                }
            }
        ];

        this.configurationManualLock = {...config.getConfiguration('StockManagementDailyTankManualLocked')};
        this.configurationManualLock.api = 'stock-management/daily-tank-manual-and-locked';
        this.configurationManualLock.enableUpdate = false;
        this.configurationManualLock.enableDelete = false;
        this.configurationManualLock.enableInsert = false;

        this.configurationManualLock.customActions = [
            {
                name: 'stockManagementDailyTankManualUnlockTankButton',
                title: 'StockManagementDailyTank.btn.manualUnlockTank',
                visible: (data) => { return data.type == "Locked" },
                cssClass: 'p-button-sm p-button-rounded p-button-warning mr-2',
                icon: 'pi pi-lock-open',
                data: {},
                fields: [],
                action: function (data, caller) {
                    caller.$emit('onStockManagementDailyTankManualUnlockTank', data);
                }
            }
        ];

        if(this.configurationAutomatic){
            this.$store.dispatch('security/setNavbarTitle', this.configurationAutomatic.title);
        }
    },
    mounted(){
        this.load();
    },
    watch: {
        'filters.referenceDate'(){
            this.load();
        },
        'filters.plantCode'(){
            this.load();
        }
    },
    methods: {
        load(){
            this.loadAutomatic();
            this.loadManual();
            this.loadManualLocked();
        },
        loadAutomatic(){
            let filters = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                plant: this.filters.plantCode
            }
            this.$refs.automaticGrid.filterFromView(filters, true);
        },
        loadManual(){
            let filters = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                plant: this.filters.plantCode
            }
            this.$refs.manualGrid.filterFromView(filters, true);
        },
        loadManualLocked(){
            let filters = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                plant: this.filters.plantCode
            }
            this.$refs.manualLockedGrid.filterFromView(filters, true);
        },
        toggleProvenance(){
            this.showProvenance = this.showProvenance ? false: true;
        },
        onDialogEditSave(item, originalItem){
            for(const key in item){
                if(key + 'Source' in item){

                    if(item[key] != originalItem[key]){
                        item[key + 'Source'] = 'Manual';
                    }
                }
            }

            
            this.$store.dispatch("generic/setLoading", true);
            Service.saveStockManagementDailyTank(item, (response) => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$refs.manualGrid.hideDialogEdit();
                    this.load();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })

        },
        showAddManual(visible){
            if(visible){
                this.editItem = {
                    referenceDate : this.filters.referenceDate,
                    type: 'Manual'
                };
            }
            this.addManualVisible = visible
        },
        onAddManual(){
            this.editItem.referenceDate =  Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1))
            for(const key in this.editItem){
                if(key + 'Source' in this.editItem){
                    this.editItem[key + 'Source'] = 'Manual';
                }
            }
            this.$store.dispatch("generic/setLoading", true);
            Service.createStockManagementDailyTank(this.editItem, (response) => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.showAddManual(false);
                    this.load();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })

        },
        onStockManagementDailyTankDelete(item){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.deleteStockManagementDailyTank(item.id, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                            this.loadManual();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        onStockManagementDailyTankManualLockTank(item){
            this.manualLockDailyTankRecordRequest.id = item.id;
            this.manualLockDailyTankRecordRequest.propagate = false;
            
            this.manualLockDialogVisible = true;
        },
        onStockManagementDailyTankManualLockTankConfirm(){
            this.$store.dispatch("generic/setLoading", true);
            Service.lockTankByDailyTank(this.manualLockDailyTankRecordRequest, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                    this.load();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
            
            this.manualLockDailyTankRecordRequest.id = null;
            this.manualLockDailyTankRecordRequest.propagate = false;

            this.manualLockDialogVisible = false;
        },
        onStockManagementDailyTankManualLockTankReject(){
            this.manualLockDailyTankRecordRequest.id = null;
            this.manualLockDailyTankRecordRequest.propagate = false;

            this.manualLockDialogVisible = false;
        },
        onStockManagementDailyTankManualUnlockTank(item){
            this.$confirm.require({
                message: this.$t('StockManagementDailyTank.manualUnlockTankMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.unlockTankByDailyTankId(item.id, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                            this.load();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        calculateStockManagement(){
            this.$confirm.require({
                message: this.$t('StockManagementDailyTank.calculateMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    let filters = {type: 'Manual', referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1))};
                    filters.tankCodes = [];
                    let d = this.$refs.manualGrid.data;
                    if(d != null && d.length > 0){
                        filters.tankCodes = d.map(function(item) {
                            return item['tankcode'];
                        });
                    }

                    this.$store.dispatch("generic/setLoading", true);
                    Service.calculateStockManagementDailyTank(filters, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                            this.load();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        reimport(){
            let referenceDate = Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1));

            this.$confirm.require({
                message: this.$t('StockManagementDailyTank.reimportMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.reimportStockManagementDailyTank(referenceDate, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                            this.load();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        exportStock(type){
            this.$confirm.require({
                message: this.$t('StockManagementDailyTank.exportMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    // this.$store.dispatch("generic/setLoading", true);

                    let params = {
                        refDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                        isTest: false
                    }

                    let plants = this.filters.plantCode ? [this.filters.plantCode] : ['ISABSUD', 'ISABNORD'];

                    switch(type){
                        case 'all':
                            plants.forEach((plant) => {
                                params.plant = plant;
                                Service.exportStockAll(params, response => {
                                    this.$store.dispatch("generic/setLoading", false);
                                    if(response.success){
                                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                    }else{
                                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                    }
                                })
                            })
                            break;
                        case 'stock':
                            plants.forEach((plant) => {
                                params.plant = plant;
                                Service.exportStockStock(params, response => {
                                    this.$store.dispatch("generic/setLoading", false);
                                    if(response.success){
                                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                    }else{
                                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                    }
                                })
                            })
                            break;
                        case 'forward':
                            plants.forEach((plant) => {
                                params.plant = plant;
                                Service.exportStockForward(params, response => {
                                    this.$store.dispatch("generic/setLoading", false);
                                    if(response.success){
                                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                    }else{
                                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                    }
                                })
                            })
                            break;
                        case 'pi':
                            plants.forEach((plant) => {
                                params.plant = plant;
                                Service.exportStockPi(params, response => {
                                    this.$store.dispatch("generic/setLoading", false);
                                    if(response.success){
                                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                    }else{
                                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                    }
                                });
                            })
                            break;
                        default:
                            break;
                    }
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        reimportExternal(type){
            let referenceDate = Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1));
            
            this.$confirm.require({
                message: this.$t('StockManagementDailyTank.reimportMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);

                    switch(type){
                        case 'lims':
                            Service.importLims(referenceDate, response => {
                                this.$store.dispatch("generic/setLoading", false);
                                if(response.success){
                                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                    this.load();
                                }else{
                                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            })
                            break;
                        case 'mts':
                            Service.importMts(referenceDate, response => {
                                this.$store.dispatch("generic/setLoading", false);
                                if(response.success){
                                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                    this.load();
                                }else{
                                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            })
                            break;
                        case 'pi':
                            Service.importPi(referenceDate, response => {
                                this.$store.dispatch("generic/setLoading", false);
                                if(response.success){
                                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                    this.load();
                                }else{
                                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            })
                            break;
                        case 'equipment':
                            Service.importEquipmentOperation(referenceDate, response => {
                                this.$store.dispatch("generic/setLoading", false);
                                if(response.success){
                                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                    this.load();
                                }else{
                                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            })
                            break;
                        default:
                            break;
                    }
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        showExcludedTanks(){
            this.excludedTanks= [];
            this.excludedTanksVisible = true;
            this.excludedTanksLoading = true;
            this.loadExcludedTanks();
        },
        loadExcludedTanks(){
            Service.getExcludedTanks((response) => {
                this.excludedTanksLoading = false;
                if(response.success){
                    this.excludedTanks = response.data;
                }
            })
        },
        onAddExcludedTank(){
            this.addTankExcluded = {};
            this.addExcludedTankVisible = true;
        },
        onDeleteExcludedTank(elem){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    Service.deleteExcludedTanks(elem.id, response => {
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                            this.loadExcludedTanks();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        onAddTankExcluded(){
             Service.createExcludedTank(this.addTankExcluded, response => {
                if(response.success){
                    this.addExcludedTankVisible = false;
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                    this.loadExcludedTanks();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        openDownloadDeltaStockReport(){
            this.chooseReportTypeDialogVisible = true;
        },
        downloadDeltaStockReport(){
            let params = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                lang: localStorage.getItem('language') ? localStorage.getItem('language').toLocaleUpperCase() : 'en',
                type: (this.selectedReportType === 'EXCEL-AUTO' || this.selectedReportType === 'PDF-AUTO') ? 'A' : '',
                reportType: this.selectedReportType.split('-')[0]
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.printDeltaStockReport(params, response => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.chooseReportTypeDialogVisible = false;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                
                    fileLink.href = fileURL;
                    let fileName = (this.selectedReportType === 'EXCEL' || this.selectedReportType === 'EXCEL-AUTO') ? "DeltaStock.xlsx" : "DeltaStock.pdf";
                    fileLink.setAttribute('download',fileName);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        sendDeltaStockReportEmail(){
            let dailyStockDate = Utils.formatDate(this.filters.referenceDate) + ' ' + this.$t('at').toLowerCase() + ' ' + this.twentyFour;
            let msg = this.$t('StockManagementDailyTank.deltaStockEmailMessage').replace('{XXX}', dailyStockDate);

            let params = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1))
            };

            this.$confirm.require({
                message: msg,
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.sendDeltaStockByEmail(params, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                            this.load();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        }
    },
    computed: {
        conf(){
            return config;
        },
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
        fieldsForDialogEdit(){
            let fields =  [];

            if(this.configurationManual && this.configurationManual.columns){
                fields = this.configurationManual.columns.filter(col => col.inLineEdit)
            }
            return fields;
        },
    },
}
</script>

<style >

</style>

<template>
    <!-- EDIT MODE DIALOG -->
    <Dialog v-model:visible="addManualVisible" :style="{width: '85vw'}" :modal="true" >
        <div class="grid">
            <div class="col-12 lg:col-4" v-for="field in fieldsForDialogEdit" :key="field.name">
                <label :for="field.name">{{$t(field.label)}}</label>
                <InputText 
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    v-if="field.type == 'string'" 
                    class="w-full"
                    v-model="editItem[field.name]" />
                <InputText 
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    class="w-full" 
                    type="number" 
                    v-if="field.type == 'number'"
                    v-model="editItem[field.name]" />
                <InputNumber
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="field.digits"
                    v-if="field.type == 'decimal'"
                    v-model="editItem[field.name]" />
                <Calendar 
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    class="w-full" 
                    v-if="field.type == 'date'"    
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="field.onlyDate ? false : true"
                    v-model="editItem[field.name]" />
                <GenericBooleanDropdown
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    v-if="field.type == 'boolean'"
                    v-model="editItem[field.name]" 
                    class="w-full" />
                <GenericCustomMasterDataAutocompleteV2
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    v-if="field.type == 'select'"
                    :name="field.name"
                    v-model="editItem[field.updateField ?? field.name]" 
                    :api="field.selectApi"
                    :format="field.selectFormat" />
                <GenericCustomAutocompleteV2
                    class="w-full"
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    v-if="field.type == 'select-simple'"
                    :name="field.name"
                    v-model="editItem[field.updateField ?? field.name]" 
                    :api="field.selectApi"
                    :format="field.selectFormat" />
                <Textarea
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    class="w-full" 
                    v-if="field.type == 'textarea'"
                    v-model="editItem[field.name]" />
            </div>
        </div>
            <template #footer>
                <Button :label="$t('btn.save')" icon="pi pi-save" @click="onAddManual" autofocus />
            </template>
    </Dialog>

    <Dialog v-model:visible="chooseReportTypeDialogVisible" :modal="true" >
        <div class="grid">
            <div class="col-12" >
                <div v-for="type in reportTypes" :key="type.value" class="flex align-items-center p-3">
                    <RadioButton v-model="selectedReportType" :inputId="type.value" name="pizza" :value="type.value" />
                    <label :for="type.key" class="ml-2">{{ type.label }}</label>
                </div>
            </div>
        </div>
        <template #footer>
            <Button :label="$t('btn.download')" icon="pi pi-download" @click="downloadDeltaStockReport" autofocus />
        </template>
    </Dialog>

    <Dialog v-model:visible="addExcludedTankVisible" :modal="true" >
        <div class="grid">
            <div class="col-12" >
                <label :for="'tankcode'">{{$t('StockManagementDailyTank.tankcode')}}</label>
                <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="tankcode"
                    v-model="addTankExcluded.tankCode" 
                    :api="'masterdata/equipment-combo?type=SERB'"
                    :format="{ label: 'label', value: 'label' }" />
            </div>
        </div>
            <template #footer>
            <Button :label="$t('btn.save')" icon="pi pi-save" @click="onAddTankExcluded" autofocus />
        </template>
    </Dialog>

    <Dialog v-model:visible="excludedTanksVisible" :modal="true" >
        <Button :label="$t('btn.add')" icon="pi pi-plus" class="p-button-sm p-button-success mr-2" @click="onAddExcludedTank" v-if="uiPermissions('stockManagementExcludedTankButtons').isEnabled" />
        <DataTable :value="excludedTanks" tableStyle="min-width: 50rem" :loading="excludedTanksLoading">
            <Column :exportable="false" v-if="uiPermissions('stockManagementExcludedTankButtons').isEnabled">
                <template #body="slotProps">
                    <Button icon="pi pi-trash" class="p-button-sm p-button-rounded p-button-warning mr-2" v-tooltip="$t('btn.delete')" @click="onDeleteExcludedTank(slotProps.data)" size="small" />
                </template>
            </Column>
            <Column field="tankCode" :header="$t('StockManagementDailyTank.tankcode')"></Column>
        </DataTable>
    </Dialog>

    <!-- Dialog congela serbatoio -->
    <Dialog v-model:visible="manualLockDialogVisible" :modal="true" >
        <div class="grid">
            <div class="col-12" style="text-align: center;">
                <span class="pi pi-exclamation-triangle" style="font-size: 3rem;"></span>
            </div>
            <div class="col-12">
                <label>{{$t('StockManagementDailyTank.manualLockTankMessage')}}</label>
            </div>
            <div class="col-12">
                <Checkbox v-model="manualLockDailyTankRecordRequest.propagate" binary style="margin-right: 5px;"/>
                <label >{{$t('StockManagementDailyTank.propagateTankLock')}}</label>
            </div>
        </div>
            <template #footer>
                <Button :label="$t('yes')" @click="onStockManagementDailyTankManualLockTankConfirm" autofocus />
                <Button :label="$t('no')" @click="onStockManagementDailyTankManualLockTankReject" autofocus />
            </template>
    </Dialog>
    
    <div class="grid">
        <div class="col-8 lg:col-2 field">
            <label for="referenceDate">{{$t('StockManagementDailyTank.referenceDate')}}</label>
            <Calendar
                :class="{'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.referenceDate"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-2 lg:col-1 field">
            <label>{{$t('at')}}</label>
            <InputText readOnly v-model="twentyFour" class="w-full " />
        </div>
         <div class="col-2 lg:col-2 field">
            <label for="plant">{{$t('registryPlant.fk')}}</label>
            <Dropdown id="plant" v-model="filters.plantCode" :options="[{value: null, label: $t('all')}, {value: 'ISABSUD', label: 'ISAB SUD'}, {value: 'ISABNORD', label: 'ISAB NORD'}]" optionLabel="label" optionValue="value" class="w-full" />
        </div>
        <div class="col-12 lg:col-7">
            <div class="p-3">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 my-1" @click="load"/>   
                <ResponsiveButton :label="$t('StockManagementDailyTank.btn.loadprovenance')" icon="pi pi-exclamation-triangle" class="mx-1 my-1" @click="toggleProvenance"/>   
                <span v-if="showProvenance">
                    <Chip class="p-2 m-1 mr-1 pi-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">PI</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 sim-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">SIM</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 lims-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">LIMS</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 manual-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">MANUAL</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 web-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">WEB</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 mts-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">MTS</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 error-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">ERROR</span>
                    </Chip>

                </span>
                <ResponsiveButton :label="$t('btn.reimport')" icon="pi pi-download" class="mx-1 my-1" @click="reimport" :disabled="!uiPermissions('stockManagementDailyTankReimport').isEnabled" />
                <SplitButton :label="$t('StockManagementDailyTank.btn.reimportExternalData')" :model="externalDataImportItems" icon="pi pi-download" class="mx-1 my-1" :disabled="!uiPermissions('stockManagementDailyTankExternalImport').isEnabled"></SplitButton>
                <ResponsiveButton :label="$t('StockManagementDailyTank.btn.tanksExcluded')" icon="pi pi-database" class="mx-1 my-1" @click="showExcludedTanks" :disabled="!uiPermissions('stockManagementDailyTanksExcluded').isEnabled"/>
                <ResponsiveButton :label="$t('StockManagementDailyTank.btn.deltaStockReport')" icon="pi pi-file" class="mx-1 my-1" @click="openDownloadDeltaStockReport" :disabled="!uiPermissions('stockManagementDailyDeltaStockReport').isEnabled"/>
                <ResponsiveButton :label="$t('StockManagementDailyTank.btn.deltaStockEmail')" icon="pi pi-envelope" class="mx-1 my-1" @click="sendDeltaStockReportEmail" :disabled="!uiPermissions('stockManagementDailyDeltaStockReportEmail').isEnabled"/>
            </div>
        </div>
        <div class="col-12" style="height: calc(80vh)">
             <TabView>
                <TabPanel :header="$t('StockManagementDailyTank.autoTab')">
                    <div class="col-12" style="height: calc(75vh)">
                        <GenericDataTable :configuration="configurationAutomatic" :category="'stock-management'" :name="'tank-automatic'" ref="automaticGrid"/>
                    </div>
                </TabPanel>
                <TabPanel :header="$t('StockManagementDailyTank.manualTab')">
                    <div class="col-12" style="height: calc(75vh)">
                        <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="mx-1 my-1" @click="showAddManual(true)" :disabled="!uiPermissions('stockManagementDailyTankInsertButton').isEnabled"/>   
                        <ResponsiveButton :label="$t('StockManagementDailyTank.btn.calculate')" icon="pi pi-calculator" class="mx-1 my-1" @click="calculateStockManagement()" :disabled="!uiPermissions('stockManagementDailyTankCalculateButton').isEnabled"/>   
                        
                        <GenericDataTable :configuration="configurationManual" :category="'stock-management'" :name="'tank-manual'" ref="manualGrid" :onDialogEditSave="onDialogEditSave" @on-stock-management-daily-tank-delete="onStockManagementDailyTankDelete" @on-stock-management-daily-tank-manual-lock-tank="onStockManagementDailyTankManualLockTank"/>
                    </div>
                </TabPanel>
                <TabPanel :header="$t('StockManagementDailyTank.manualLockTab')">
                    <div class="col-12" style="height: calc(75vh)">
                        <SplitButton :label="$t('StockManagementDailyTank.btn.export')" :model="exportItems" icon="pi pi-download" class="mx-1 my-1" :disabled="!uiPermissions('stockManagementDailyTankExport').isEnabled"></SplitButton>
                        <GenericDataTable :configuration="configurationManualLock" :category="'stock-management'" :name="'tank-manual-locked'" ref="manualLockedGrid" @on-stock-management-daily-tank-manual-unlock-tank="onStockManagementDailyTankManualUnlockTank"/>
                    </div>
                </TabPanel>
            </TabView>
        </div>
    </div>
</template>